import ApiService from './api-service';

const TaskService = {
  async getTasks({ shortCode, status, type, assignee, source, page, pageSize, sort, search }) {
    const body = {
      query: `
        query($assignee: String, $type: String, $status: String, $source: String, $page: Int, $pageSize: Int, $sort: String, $search: String) {
          organisation {
            tasks(assignee: $assignee, type: $type, status: $status, source: $source, page: $page, pageSize: $pageSize, sort: $sort, search: $search) {
              nodes {
                _id
                type
                category
                status
                source
                assignee {
                  _id
                  profile {
                    firstName
                    lastName
                  }
                }
                completedBy {
                  _id
                  profile {
                    firstName
                    lastName
                  }
                }
                dueDate
                createdDate
                completedDate
                rescheduledDate
                description
                metadata {
                  contact {
                    Name
                    ContactID
                    Phones {
                      PhoneNumber
                      PhoneAreaCode
                      PhoneType
                      PhoneCountryCode
                    }
                  }
                  invoices {
                    _id
                    InvoiceNumber
                    InvoiceID
                    Status
                    paymentPlan {
                      instalments {
                        dueDate
                      }
                    }
                  }
                  overdueAmount
                  result
                  notes
                }
              }
              totalCount
            }
          }
        }`,
      variables: {
        assignee,
        status,
        type,
        source,
        page,
        pageSize,
        sort,
        search,
      },
    };

    const data = await ApiService.orgEndpoint(shortCode).post('/', body);
    return data.organisation.tasks || [];
  },
  async createTask({
    type,
    assignee,
    metadata,
    status,
    dueDate,
    description,
    rescheduledDate,
    shortCode,
  }) {
    const body = {
      query: `mutation createTask ($type: String!, $assignee: String, $metadata: CreateTaskMetadataType, $status: String, $dueDate: Date, $description: String, $rescheduledDate: Date) {
        createTask (type: $type, assignee: $assignee, metadata: $metadata, status: $status, dueDate: $dueDate, description: $description, rescheduledDate: $rescheduledDate) {
          _id
        }
      }`,
      variables: {
        type,
        assignee,
        metadata,
        status,
        dueDate,
        description,
        rescheduledDate,
      },
    };
    const data = await ApiService.orgEndpoint(shortCode).post('/', body);

    return data.createTask;
  },
  async updateTask({
    taskId,
    assignee,
    completedBy,
    metadata,
    status,
    dueDate,
    description,
    rescheduledDate,
    shortCode,
  }) {
    const body = {
      query: `mutation updateTask ($taskId: String!, $status: String!, $assignee: String, $completedBy: String, $metadata: UpdateTaskMetadataType, $dueDate: Date, $description: String, $rescheduledDate: Date) {
        updateTask (taskId: $taskId, assignee: $assignee, completedBy: $completedBy, metadata: $metadata, status: $status, dueDate: $dueDate, description: $description, rescheduledDate: $rescheduledDate) {
          _id
        }
      }`,
      variables: {
        taskId,
        assignee,
        completedBy,
        metadata,
        status,
        dueDate,
        description,
        rescheduledDate,
      },
    };
    const data = await ApiService.orgEndpoint(shortCode).post('/', body);

    return data.createTask;
  },
  async checkTasksAndScheduleRemindersForUsers({ userId, shortCode }) {
    const body = {
      query: `mutation checkTasksAndScheduleRemindersForUsers ($userId: String!) {
        checkTasksAndScheduleRemindersForUsers (userId: $userId)
      }`,
      variables: {
        userId,
      },
    };
    const data = await ApiService.orgEndpoint(shortCode).post('/', body);

    return data.checkTasksAndScheduleRemindersForUsers;
  },
  async reassignTasksAndScheduleReminders({ oldUserId, newUserId, shortCode }) {
    const body = {
      query: `mutation reassignTasksAndScheduleReminders ($oldUserId: String!, $newUserId: String!) {
        reassignTasksAndScheduleReminders (oldUserId: $oldUserId, newUserId: $newUserId)
      }`,
      variables: {
        oldUserId,
        newUserId,
      },
    };
    const data = await ApiService.orgEndpoint(shortCode).post('/', body);

    return data.reassignTasksAndScheduleReminders;
  },
  async getCustomTasks(ShortCode) {
    const body = {
      query: `query {
        organisation {
          customTasks
        }
      }
      `,
    };

    const data = await ApiService.orgEndpoint(ShortCode).post('/', body);
    return data.organisation;
  },
  async setCustomTasks({ customTasks, shortCode }) {
    const body = {
      query: `mutation setCustomTasks ($customTasks: [String]!) {
        setCustomTasks (customTasks: $customTasks)
      }`,
      variables: {
        customTasks,
      },
    };
    const data = await ApiService.orgEndpoint(shortCode).post('/', body);
    return data.setCustomTasks;
  },
};

export default TaskService;
